<script setup lang="ts">
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { getColorValue } from '@global-types/colors';
import { type IconProps } from '@global-types/icon';

const props = defineProps<IconProps>();

const colorValue = computed<string | undefined>(() => {
  if (props.fill === undefined) {
    return undefined;
  }

  if (props.fill === 'current') {
    return 'currentColor';
  }

  if (props.fill === 'none') {
    return 'none';
  }

  return getColorValue(props.fill);
});

const strokeColorValue = computed<string | undefined>(() => {
  if (props.stroke === undefined) {
    return undefined;
  }

  if (props.stroke === 'current') {
    return 'currentColor';
  }

  return getColorValue(props.stroke);
});
</script>

<template>
  <InlineSvg
    :src="svg"
    :class="customClass"
    :title="title"
    :width="width"
    :height="height"
    :fill="colorValue"
    :style="stroke ? { color: strokeColorValue } : undefined"
  />
</template>
